import { c as _c } from "react/compiler-runtime";
import type { HTMLAttributes, ReactElement } from 'react';
import { cn } from '#cn';
import { getToneClass, type TextTone } from './typography-tones';
type HeadingVariant = 'hero' | 'display' | 'headline' | 'title' | 'subtitle' | 'section' | 'eyebrow';
type HeadingLevel = 1 | 2 | 3 | 4;
type HeadingProps = HTMLAttributes<HTMLHeadingElement> & {
  variant?: HeadingVariant;
  level: HeadingLevel;
  tone?: TextTone;
};
const variantClasses: Record<HeadingVariant, string> = {
  hero: 'text-7xl font-black tracking-tight leading-none',
  display: 'text-5xl font-black tracking-tight leading-none',
  headline: 'text-4xl font-black tracking-tight',
  title: 'text-3xl font-black tracking-tight uppercase',
  subtitle: 'text-2xl font-black tracking-tight',
  section: 'text-xl font-extrabold',
  eyebrow: 'text-lg font-black tracking-tight uppercase'
};

/** A semantic heading (`level` sets the `h1`–`h4` tag) styled by one of the named type `variant`s (`hero` down to `eyebrow`), independent of the tag. */
export const Heading = t0 => {
  const $ = _c(16);
  let children;
  let className;
  let level;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      children,
      variant: t1,
      level,
      tone: t2,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = level;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
  } else {
    children = $[1];
    className = $[2];
    level = $[3];
    props = $[4];
    t1 = $[5];
    t2 = $[6];
  }
  const variant = t1 === undefined ? "section" : t1;
  const tone = t2 === undefined ? "default" : t2;
  const Tag = `h${level}`;
  const t3 = variantClasses[variant];
  let t4;
  if ($[7] !== className || $[8] !== t3 || $[9] !== tone) {
    t4 = cn(t3, getToneClass(tone), className);
    $[7] = className;
    $[8] = t3;
    $[9] = tone;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== Tag || $[12] !== children || $[13] !== props || $[14] !== t4) {
    t5 = <Tag className={t4} {...props}>{children}</Tag>;
    $[11] = Tag;
    $[12] = children;
    $[13] = props;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};